export default '/build/947c202e.svg'